"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Address = void 0;
/**
 * Represents an address with a unique identifier.
 */
class Address {
    /**
     * Constructs a new Address instance.
     * @param {IAddress} param0 - Object containing the address id.
     */
    constructor({ id }) {
        this.id = id;
    }
    /**
     * Creates an Address instance from a JSON object.
     * @param {any} json - JSON object containing the address data.
     * @returns {Address} A new Address instance.
     */
    static fromJson(json) {
        return new Address(json);
    }
    /**
     * Converts the Address instance to a JSON object.
     * @returns {object} JSON representation of the Address instance.
     */
    toJson() {
        return {
            id: this.id,
        };
    }
}
exports.Address = Address;
